import React from 'react';
import '../../css/Login.css';
import Warning from "../../images/warning.png";
import Correct from "../../images/correct.svg";

const ResetPassword = (props) => {
	const {
		close,
		onChangeHandler,
		CheckRequiredFields,
		requiredFields,
		details,
		validatePassword,
		disableConfirmPassword,
		violetRule,
		checkCaseOfString,
		checkCaseOfNum,
		passwordMatchError,
		comparePaswordONBlur
	} = props;

	const showPassWord = (name, target) => {
		var temp = document.getElementById(target);
		if (temp.type === 'password') {
			temp.type = 'text';
			document.getElementById(name).classList.add('fa-eye-slash');
		} else {
			temp.type = 'password';
			document.getElementById(name).classList.remove('fa-eye-slash');
		}
	};

	return (
		<div className="card employee-application-card-style-1">
			<div>
				<div className="formHeader">
					<h3 className="headTypo">
						Reset password
						<button type="button" className="removeButton" onClick={close}>
							&times;
						</button>
					</h3>
				</div>
				<div className="formBody">
					<div className="form-group has-feedback formWrapper">
						<p style={{ marginBottom: 25 }}>Please enter your new password below</p>
					</div>
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							New Password
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							name="password"
							type="password"
							onChange={onChangeHandler}
							placeholder="Password"
							autoComplete="off"
							value={details.password}
							id="registerPassword"
							onBlur={() => validatePassword(details.password)}
						/>
						<span
							className="fa fa-eye field-icon"
							id="registerPassCode"
							onClick={showPassWord.bind(this, 'registerPassCode', 'registerPassword')}
						/>
						{requiredFields.passwordReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter your password
							</p>
						) : null}
						{/* rule here  */}
						<p className='px-2  m-0'>
							{checkCaseOfString(details.password) ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "0.8rem", color: (violetRule.isSmallAndCap && !checkCaseOfString(details.password)) ? "red" : "inherit" }}
							>
								Includes both Capital and Small Letters</span>
						</p>
						<p className='px-2  m-0'>
							{checkCaseOfNum(details.password) ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "0.8rem", color: (violetRule.isNumOrSpecial && !checkCaseOfNum(details.password)) ? "red" : "inherit" }}
							>
								Includes Numerical and Special characters</span>
						</p>
						<p className='px-2  m-0'>
							{details.password?.length > 8 ?
								<img src={Correct} alt="correct" width="15" height="15" />
								: <img src={Warning} alt="warning" width="15" height="15" />
							}
							<span className='pl-1'
								style={{ fontSize: "0.8rem", color: (violetRule.valideLength && !(details.password?.length > 8)) ? "red" : "inherit" }}
							>Includes more than 8 characters</span>
						</p>
					</div>
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							Confirm New Password
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							name="confirmPassword"
							type="password"
							onChange={onChangeHandler}
							placeholder="Password"
							autoComplete="off"
							value={details.confirmPassword}
							id="registerConfirmPassword"
							disabled={disableConfirmPassword}
							onBlur={comparePaswordONBlur}
						/>
						<span
							className="fa fa-eye field-icon"
							id="registerConfirmPassCode"
							onClick={showPassWord.bind(
								this,
								'registerConfirmPassCode',
								'registerConfirmPassword'
							)}
						/>
						{requiredFields.confirmPasswordReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please confirm your password
							</p>
						) : null}
						{passwordMatchError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" /> Passwords are not matching
							</p>
						) : null}
					</div>
				</div>

				<div className="formFooter">
					<button className="ContinueButton" onClick={()=>CheckRequiredFields('password')}>
						Change my password
					</button>
					<br />
				</div>
			</div>
		</div>
	);
};

export default ResetPassword;
